import { render, staticRenderFns } from "./UserPermissionsTagTable.vue?vue&type=template&id=2cf4920f&scoped=true&"
import script from "./UserPermissionsTagTable.vue?vue&type=script&lang=js&"
export * from "./UserPermissionsTagTable.vue?vue&type=script&lang=js&"
import style0 from "./UserPermissionsTagTable.vue?vue&type=style&index=0&id=2cf4920f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf4920f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VRow,VSelect,VSimpleTable,VTextField})
